export default "__VITE_ASSET__c4f5257b__"